import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CheckoutRoutingModule } from './checkout-routing.module';
import { CheckoutComponent } from './checkout/checkout.component';
import { SelectShipmentComponent } from './select-shipment/select-shipment.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MapComponent } from './map/map.component';
import { CargoComponent } from './cargo/cargo.component';
import { CheckoutAddressComponent } from './checkout-address/checkout-address.component';
import { SelectPaymentComponent } from './select-payment/select-payment.component';
import { AgmCoreModule } from '@agm/core';
import { CreditCardFormComponent } from './credit-card-form/credit-card-form.component';
// import {NgxPayPalModule} from 'ngx-paypal';
import { PaypalComponent } from './paypal/paypal.component';
import { PaypalNativeComponent } from './paypal-native/paypal-native.component';



@NgModule({
    declarations: [CheckoutComponent, SelectShipmentComponent, MapComponent, CargoComponent, CheckoutAddressComponent,
        SelectPaymentComponent, CreditCardFormComponent, PaypalComponent,
        PaypalNativeComponent
    ],
    exports: [
        PaypalNativeComponent
    ],
    imports: [
        CommonModule,
        CheckoutRoutingModule,
        SharedModule,
        AgmCoreModule.forRoot(
            {
                apiKey: 'AIzaSyA71bOtduE_jldZ_xdW-xDiNawDDQLsYNs'
            }
        ),
        // NgxPayPalModule
    ]
})
export class CheckoutModule { }
